import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,{staticClass:"mx-0"},[_c('AppointmentEditView',{attrs:{"app-bar-title":_vm.appBarTitle,"appointment":_vm.selectedAppointment,"saving":_vm.saving,"error":_vm.error,"finished":_vm.finished},on:{"saveAppointment":_vm.onSaveAppointment,"setFinished":function($event){return _vm.setFinished()}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }